import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 24,
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    gap: 60,
    [theme.breakpoints.down('xs')]: {
      gap: 20,
    },
  },
  item: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
    maxWidth: '150px',
  },
  countTu: {
    color: theme.palette.common.white,
    margin: '0',
    fontFamily: 'Merriweather, sans-serif',
  },
  circle: {
    width: '58px',
    height: '58px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  blueCircle: {
    backgroundColor: theme.custom.blue[0],
  },
  greenCircle: {
    backgroundColor: theme.custom.green[1],
  },
  icon: {
    color: theme.palette.common.white,
  },
  text: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: '12px',
    lineHeight: '21px',
    whiteSpace: 'pre-wrap',
  },
}));
